import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import UpgradeModal from './UpgradeModal';
import { PAYWALL_EVENT } from '../../utils/paywall';

/**
 * Mounted once in the root layout. Opens the plan picker whenever a button or
 * a 402 PAYWALL answer from the server asks for it (see utils/paywall).
 */
export default function PaywallHost() {
  const { user } = useSelector((s) => s.auth);
  const [action, setAction] = useState(null);

  useEffect(() => {
    const onPaywall = (e) => setAction(e.detail?.action || 'publish');
    window.addEventListener(PAYWALL_EVENT, onPaywall);
    return () => window.removeEventListener(PAYWALL_EVENT, onPaywall);
  }, []);

  return (
    <UpgradeModal
      open={Boolean(action)}
      onClose={() => setAction(null)}
      resource={action}
      currentPlan={user?.subscription?.plan || null}
    />
  );
}
